import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { qualifiesForEpTradeProfile } from '@uo/shared';
import { usersAPI } from '../api/users';
import { useAuthStore, type UserProfile } from '../store/auth';

/** A3+ gate for EP trading hall (服务级优先). */
export function useEpTradeEligible() {
  const storeProfile = useAuthStore((s) => s.profile);
  const setProfile = useAuthStore((s) => s.setProfile);

  const profileQuery = useQuery({
    queryKey: ['ep-trade-access-profile'],
    queryFn: async () => {
      const p = (await usersAPI.getProfile()) as UserProfile;
      setProfile(p);
      return p;
    },
    staleTime: 30_000,
  });

  const profile = profileQuery.data ?? storeProfile;
  const eligible = useMemo(
    () =>
      qualifiesForEpTradeProfile({
        level_code: profile?.level_code,
        reward_level_code: profile?.profile_metrics?.reward_level_code,
      }),
    [profile?.level_code, profile?.profile_metrics?.reward_level_code],
  );

  return {
    eligible,
    loading: profileQuery.isLoading && !storeProfile,
    profile,
  };
}
